import { defineStore } from 'pinia'

export const useVariationStore = defineStore('variationState', () => {
  const { API_ENDPOINTS } = useApiEndpoints()
  const toast = useCustomToast()

  const variations = ref([])
  const transformedVariations = ref([])

  const isExistVariations = computed(() => variations.value.length > 0)

  const fetchVariations = async (productId) => {
    if (!productId) {
      return
    }
    const response = await useBaseOFetchWithAuth(
      API_ENDPOINTS.protected.products.variations.getVendor(productId)
    )
    variations.value = response.variations
  }

  const deleteVariation = async (item) => {
    item.loading = true
    await useBaseOFetchWithAuth(
      API_ENDPOINTS.protected.vendor.variations.delete(item.id),
      {
        method: 'DELETE'
      }
    )
    deleteVariationOnState(item.id)
    item.loading = false
  }

  const deleteVariationOnState = (id) => {
    variations.value = variations.value.filter(
      (variation) => variation.id !== id
    )
  }

  const createAllVariation = async (productId) => {
    await useBaseOFetchWithAuth(
      API_ENDPOINTS.protected.products.variations.create(productId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    toast.success('Varyantlar başarıyla oluşturuldu')
  }

  const setErrorOnVariation = (id, error) => {
    const variation = variations.value.find((variation) => variation.id === id)
    if (variation) {
      variation.error = error
    }
  }

  return {
    variations,
    transformedVariations,
    isExistVariations,
    fetchVariations,
    deleteVariation,
    createAllVariation,
    setErrorOnVariation
  }
})
